import * as commonScripts from '../common'
import Glide from '@glidejs/glide'

const cmpContentCard = {
  component: null,

  init: function (element) {
    const _ = this
    _.component = element
    commonScripts.util.animationTranslate(this)

    // If not in edit mode, then initialize the carousel
    if (!commonScripts.util.isEditMode()) {
      const carouselId = _.component.getAttribute('data-carousel-id')
      const carouselDiv = _.component.querySelector(
        '#' + carouselId + ' .glide'
      )
      if (carouselDiv) {
        const autoplay = _.component.getAttribute('data-autoplay')
        let loop = _.component.getAttribute('data-loop')
        loop = loop ? loop.toLowerCase() : loop

        const options = {}
        options.gap = 31
        options.perView = 2
        options.focusAt = 0
        options.startAt = 0
        options.direction = _.component.getAttribute('data-direction')
        options.type = loop === "'true'" ? 'carousel' : 'slider'
        options.rewind = options.type == 'slider' ? false : true
        options.autoplay =
          isNaN(autoplay) || autoplay === '0' ? false : autoplay * 1000
        options.breakpoints = {
          767: {
            perView: 1,
          },
          1024: {
            perView: 2,
            gap: 31
          },
          1440: {
            perView: 2,
            gap: 31
          },
          1920: {
            perView: 3,
            gap: 31,
          }
        }
        const glide = new Glide(carouselDiv, options)

        // Add click listener for each slide on carousel. Get slide index for change it on click.
        glide.on('mount.after', function () {
          const carousel = document.querySelector('#' + carouselId)
          carousel.querySelectorAll('.glide__slide').forEach((slide) => {
            slide.addEventListener('click', function (e) {
              let index = parseInt(this.getAttribute('data-index'))
              if (index === 0 || index > 0) {
                index = '=' + index
                glide.go(index)
              }
            })
          })
        })

        glide.mount()

        let glideActiveIndex = null
        // prevents re-render when click on any part of carousel
        if (glideActiveIndex === glide.index) return
        glideActiveIndex = glide.index

        glide.on('move.after', function () {
          // disable arrow if loop is false
          if (loop === "'false'") {
            const carousel = document.querySelector('#' + carouselId)
            const carouselLength =
              carousel.querySelectorAll('.glide__slide').length
            const left = carousel.querySelector('.glide__arrow--left')
            if (carouselLength === 1) {
              if (left) {
                left.setAttribute('disabled', '')
              }
            }
            if (glide.index === 0) {
              if (left) {
                left.setAttribute('disabled', '')
              }
            } else {
              if (left) {
                left.removeAttribute('disabled')
              }
            }
            const right = carousel.querySelector('.glide__arrow--right')
            if (right) {
              let length = carouselLength
              if (window.screen.width >= 1440) {
                length = carouselLength + 2
              }
              if ((window.screen.width > 767 && window.screen.width < 1440) || window.screen.width > 1920) {
                length = carouselLength + 1
              }

              if (glide.index === length - glide.settings.perView) {
                right.setAttribute('disabled', '') // Disable on last slide
              }
              else {
                right.removeAttribute('disabled')
              }
            }
          }

          const slideDiv = document.querySelector('#' + carouselId)

          const content = slideDiv.querySelector(
            '.glide__slide--active .content'
          ).innerHTML
          const dynamicContainer = slideDiv.querySelector('.dynamic-container')
          dynamicContainer.innerHTML = content

          // remove and add active class in order to generate fade effect
          dynamicContainer.classList.remove('active')
          dynamicContainer
            .querySelector('.cmp-three-pieces-carousel__slide__left-container')
            .classList.remove(
              'cmp-three-pieces-carousel__slide__left-container--active'
            )

          dynamicContainer.classList.add('active')
          dynamicContainer
            .querySelector('.cmp-three-pieces-carousel__slide__left-container')
            .classList.add('cmp-three-pieces-carousel__slide__left-container--active')
        })
      }
    }
  }
}

export default cmpContentCard
